module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: 'rt-picklist ' + (_vm.iconSrc ? 'hasprefixicon' : ''),
    on: {
      "mouseenter": function($event) {
        _vm.inputHovering = true
      },
      "mouseleave": function($event) {
        _vm.inputHovering = false
      }
    }
  }, [_c('rt-icon', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.iconSrc),
      expression: "iconSrc"
    }],
    class: {
      prefixicon: _vm.iconSrc
    },
    attrs: {
      "img-src": _vm.iconSrc
    }
  }), _vm._v(" "), _c('el-select', {
    ref: "elSelect",
    class: {
      'is-disabled': _vm.computedDisabled
    },
    attrs: {
      "disabled": _vm.computedDisabled,
      "multiple": _vm.multiple,
      "filterable": _vm.filterable,
      "size": _vm.size,
      "show-max-selected": _vm.showMaxSelected,
      "placeholder": _vm.computedSelectPlaceholder,
      "collapse-tags": _vm.multiple,
      "clearable": "",
      "is-picklist": "",
      "popper-class": "rt-picklist-popper",
      "remote": _vm.remote,
      "loading": _vm.loading,
      "remote-method": _vm.remoteMethod,
      "filter-method": _vm.filterMethod
    },
    on: {
      "change": _vm.handleChange,
      "visible-change": _vm.visibleChange
    },
    model: {
      value: (_vm.selectedValue),
      callback: function($$v) {
        _vm.selectedValue = $$v
      },
      expression: "selectedValue"
    }
  }, [(_vm.isGroup) ? _vm._l((_vm.dataSource), function(group, index) {
    return _c('el-option-group', {
      key: group[_vm.nameKey] || index,
      attrs: {
        "label": group[_vm.nameKey] ? group[_vm.nameKey] : ''
      }
    }, _vm._l((group.options), function(item, optionIndex) {
      return _c('el-option', {
        key: item[_vm.valueKey],
        attrs: {
          "label": item[_vm.nameKey],
          "value": item[_vm.valueKey],
          "disabled": item.disabled,
          "multiple": _vm.multiple
        }
      }, [_vm._t("default", function() {
        return [(item.IconSrc || item.iconSrc || item.iconName) ? _c('rt-icon', {
          staticClass: "rt-picklist-dropdown-item-prefix",
          attrs: {
            "img-src": item.IconSrc || item.iconSrc,
            "name": item.iconName,
            "size": item.iconSize,
            "color": item.iconColor
          }
        }) : _vm._e(), _vm._v(" "), _c('div', {
          staticClass: "rt-picklist-dropdown-item-label-box"
        }, [_c('span', {
          staticClass: "rt-picklist-dropdown-item-label"
        }, [_vm._v("\n                " + _vm._s(item[_vm.nameKey]) + "\n              ")]), _vm._v(" "), (item[_vm.optionDescField]) ? [(typeof item[_vm.optionDescField] === 'string') ? _c('div', {
          staticClass: "rt-picklist-dropdown-item-desc"
        }, [_vm._v("\n                  " + _vm._s(item[_vm.optionDescField]) + "\n                ")]) : _vm._l((item[_vm.optionDescField]), function(n, i) {
          return _c('div', {
            key: n.label + '-' + n.value + '-' + i,
            staticClass: "rt-picklist-dropdown-item-desc"
          }, [_vm._v("\n                    " + _vm._s(n.label + ': ' + n.value) + "\n                  ")])
        })] : _vm._e()], 2)]
      }, {
        "option": item,
        "index": optionIndex
      })], 2)
    }), 1)
  }) : _vm._l((_vm.dataSource), function(item, optionIndex) {
    return _c('el-option', {
      key: item[_vm.valueKey],
      attrs: {
        "label": item[_vm.nameKey],
        "value": item[_vm.valueKey],
        "disabled": item.disabled,
        "multiple": _vm.multiple
      }
    }, [_vm._t("default", function() {
      return [_c('div', {
        staticClass: "rt-picklist-dropdown-item-label-box"
      }, [(item.IconSrc || item.iconSrc || item.iconName) ? _c('rt-icon', {
        staticClass: "rt-picklist-dropdown-item-prefix",
        attrs: {
          "img-src": item.IconSrc || item.iconSrc,
          "name": item.iconName,
          "size": item.iconSize,
          "color": item.iconColor
        }
      }) : _vm._e(), _vm._v(" "), _c('span', {
        staticClass: "rt-picklist-dropdown-item-label",
        domProps: {
          "innerHTML": _vm._s(_vm.highlightQueryString(item[_vm.nameKey]))
        }
      }), _vm._v(" "), (!_vm.hideOptionDesc && item[_vm.optionDescField]) ? [(typeof item[_vm.optionDescField] === 'string') ? _c('div', {
        staticClass: "rt-picklist-dropdown-item-desc"
      }, [_vm._v("\n                " + _vm._s(item[_vm.optionDescField]) + "\n              ")]) : _vm._l((item[_vm.optionDescField]), function(n, i) {
        return _c('div', {
          key: n.label + '-' + n.value + '-' + i,
          staticClass: "rt-picklist-dropdown-item-desc"
        }, [_vm._v("\n                  " + _vm._s(n.label + ': ' + n.value) + "\n                ")])
      })] : _vm._e()], 2)]
    }, {
      "option": item,
      "index": optionIndex
    })], 2)
  })], 2), _vm._v(" "), _c('rt-icon', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.computedDisabled && _vm._computedSuffixIcon),
      expression: "!computedDisabled && _computedSuffixIcon"
    }],
    staticStyle: {
      "pointer-events": "none"
    },
    attrs: {
      "name": "rt-base-dropdown"
    }
  }), _vm._v(" "), (_vm.showClose) ? _c('rt-icon', {
    staticClass: "rt-xpc-picklist-clearicon",
    style: (_vm.computedClearIconStyle),
    attrs: {
      "name": _vm.computedIconName
    },
    on: {
      "click": _vm.clear
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-44ccebf0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vue-xpc/src/components/picklist/index.vue
// module id = 2077
// module chunks = 228